// ============================================
// Firebase Configuration
// ============================================

export const firebaseConfig = {
  apiKey: "AIzaSyAL9rIsYmWLbVBb_p-uQsnhSYs602iuHec",
  authDomain: "walletolab.com",
  projectId: "walleto-dm4k8x",
  storageBucket: "walleto-dm4k8x.firebasestorage.app",
  messagingSenderId: "12629629702",
  appId: "1:12629629702:web:15c5b554796a1c9b5b5c87",
  measurementId: "G-K11WEXVEL6",
};

// Use window.firebase since it's loaded via CDN in index.html
export let app = null;
export let auth = null;
export let provider = null;
export let db = null;

if (typeof window !== "undefined" && window.firebase) {
  app = window.firebase.initializeApp(firebaseConfig);
  auth = window.firebase.auth();
  provider = new window.firebase.auth.GoogleAuthProvider();
  db = window.firebase.firestore();
} else {
  console.warn("Offline mode: Firebase skipped.");
}

// ============================================
// CONSTANTS AND CONFIGURATION
// ============================================

export const API_BASE_URL = "https://walleto-bot.onrender.com";
export const MIN_SCALE = 1.0;
export const MAX_SCALE = 4.0;
export const SCALE_STEP = 0.5;

// Group all mutable (changing) variables into one state object
export const AppState = {
  SESSION_ID: "",
  email: "",
  user_uid: "guest",
  DISPLAY_NAME: "Guest",
  isLoggedIn: false,
  hasShownLoginModal: false,
  currentView: "flyers",
  selectedCountryCode: "CA",
  selectedCountryName: "Canada",
  currentDealCard: null,
  currentMerchant: null,
  modalMode: "gallery",
  currentScale: 1,
  flyerImages: [],
  currentImageIndex: 0,
  merchantFlyersMap: new Map(),
  allFlyers: [],
  conversationHistory: []
};

// ============================================
// COUNTRY STATE
// ============================================
export function getCountryNameFromCode(code) {
  return code === "CA" ? "Canada" : "United States";
}

const savedCountry = localStorage.getItem("walleto_country");
if (savedCountry && (savedCountry === "CA" || savedCountry === "US")) {
  AppState.selectedCountryCode = savedCountry;
  AppState.selectedCountryName = getCountryNameFromCode(savedCountry);
}

const savedLocation = localStorage.getItem("walleto_location");
if (savedLocation) {
  try {
    const locData = JSON.parse(savedLocation);
    AppState.mapped_city = locData.mapped_city || locData.mappedCity || locData.city || "Milton";
    AppState.city = AppState.mapped_city;
  } catch (e) {
    AppState.city = "Milton";
    AppState.mapped_city = "Milton";
  }
} else {
  AppState.city = "Milton";
  AppState.mapped_city = "Milton";
}

// ============================================
// DOM ELEMENTS
// ============================================

export const menuToggle = document.getElementById("menuToggle");
export const dropdownMenu = document.getElementById("dropdownMenu");
export const countryToggle = document.getElementById("countryToggle");
export const countryMenu = document.getElementById("countryMenu");
export const countryOptions = countryMenu ? countryMenu.querySelectorAll("a") : [];
export const navOptions = document.querySelectorAll(".nav-options li");
export const loginToggle = document.getElementById("loginToggle");
export const loginModal = document.getElementById("loginModal");
export const loginModalClose = document.getElementById("loginModalClose");
export const googleLogin = document.getElementById("googleLogin");
export const chatInput = document.getElementById("chatInput");
export const sendBtn = document.getElementById("sendBtn");
export const dealModalPageNo = document.getElementById("dealModalPageNo");
export const chatBody = document.getElementById("chatBody");
export const apiStatus = document.getElementById("apiStatus");
export const usernameElement = document.getElementById("username");
export const navUsernameElement = document.getElementById("navUsername");
export const navProfileImg = document.getElementById("navProfileImg");
export const imageModal = document.getElementById("imageModal");
export const modalClose = document.getElementById("modalClose");
export const modalBackBtn = document.getElementById("modalBackBtn");
export const thumbnailStrip = document.getElementById("thumbnailStrip");
export const modalImage = document.getElementById("modalImage");
export const zoomInBtn = document.getElementById("zoomIn");
export const zoomOutBtn = document.getElementById("zoomOut");
export const resetZoomBtn = document.getElementById("resetZoom");
export const zoomLevel = document.getElementById("zoomLevel");
export const modalContent = document.querySelector(".modal-content");
export const prevBtn = document.getElementById("prevBtn");
export const nextBtn = document.getElementById("nextBtn");
export const galleryPrevBtn = document.getElementById("galleryPrevBtn");
export const galleryNextBtn = document.getElementById("galleryNextBtn");
export const imageCounter = document.getElementById("imageCounter");
export const flyersContainer = document.getElementById("flyersContainer");
export const stickyHeading = document.querySelector(".sticky-heading");
export const chatHeaderImg = document.querySelector(".chat-header .felix-img");
export const dealModal = document.getElementById("dealModal");
export const dealModalOverlay = document.querySelector(".deal-modal-overlay");
export const dealModalImage = document.getElementById("dealModalImage");
export const dealModalMerchant = document.getElementById("dealModalMerchant");
export const dealModalProduct = document.getElementById("dealModalProduct");
export const dealModalOfferPrice = document.getElementById("dealModalOfferPrice");
export const dealModalRegularPrice = document.getElementById("dealModalRegularPrice");
export const dealModalWeight = document.getElementById("dealModalWeight");
export const dealModalExpiryDate = document.getElementById("dealModalExpiryDate");
export const dealModalFavoriteBtn = document.getElementById("dealModalFavoriteBtn");
export const dealModalClose = document.getElementById("dealModalClose");